import { useTranslation } from 'react-i18next';
import useProgress from 'src/hook/data/useProgress';
import useUser from 'src/hook/data/useUser';
import { useIFrameModal } from 'src/hook/modal/useIFrameModal';
import usePopUp from 'src/hook/modal/usePopUp';
import { UserFields } from 'src/model/enum/dataEnums';
import { GetLikeUrl, GetRazorSiteUrl, ImageLocation } from 'src/utils/URLUtils';
import styles from './RatingPopUp.module.scss';


const RatingPopUp = () => {
    const { hide, show } = usePopUp();
    const { userInfo } = useUser();
    const { open } = useIFrameModal();
    const { updateUserInfoField } = useProgress();
    const { t, i18n } = useTranslation();

    

    const handleRate = async (rate: string) => {
        updateUserInfoField(UserFields.FeedbackGiven, true);
        hide();
        if (rate === 'love') {
            window.open(GetLikeUrl(), '_blank');
        } else if (rate === 'like') {
            window.open(GetLikeUrl(), '_blank');

        } else if (rate === 'not sure') {
            show({
                title: 'Feedback?',
                message: 'Is there anything you\'d like us to improve?',
                primaryButtonText: 'Yes',
                primaryButtonClick: () => {
                    hide();
                    open(GetRazorSiteUrl('support/idea', userInfo?.Token));
                },
                showSecondaryButton: true,
                secondaryButtonText: 'No',
                secondaryButtonClick: () => {
                    hide();
                }
            });
        }

    };

    return (
        <div className={styles.ratingPopUp}>
            <h1 dir={i18n.dir()}> {t('How do you feel about WordUp?')}</h1>
            <div className={styles.selection} onClick={() => handleRate('love')}>
                <span>{t('I love it')}</span>
                <img src={ImageLocation('Lexi/01_love_it.png')} alt="love" />
            </div>
            <div className={styles.selection} onClick={() => handleRate('like')}>
                <span>{t('I like it')}</span>
                <img src={ImageLocation('Lexi/02_like_it.png')} alt="like" />
            </div>
            <div className={styles.selection} onClick={() => handleRate('not sure')}>
                <span>{t("I'm not sure")}</span>
                <img src={ImageLocation('Lexi/03_not_sure.png')} alt="not sure" />
            </div>
        </div>
    );
};

export default RatingPopUp;